export const useStoreHeader = defineStore('StoreHeader', {
    state: () => ({
        menuOpen: false,
    }),
    actions: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenu() {
            this.menuOpen = false;
        },
    },
});
